module.exports = __webpack_public_path__ + "img/download.7dbfe9fa.svg";